// @flow
import React, { Component } from 'react';
import { compose } from 'redux';
import { type CategoryData } from 'store/modules/common';
import { type ContextRouter, withRouter, type Location } from 'react-router-dom';
import './MainMobileHead.scss';
import MainMobileHeadItem from '../MainMobileHeadItem';

type Props = {
  location: Location,
  categories: ?(CategoryData[]),
} & ContextRouter;

type State = {
  isMouseOverMenu: boolean,
};

class MainMobileHead extends Component<Props, State> {
  state = {
    isMouseOverMenu: false,
  };

  handleMouseOverMenu = () => {
    this.setState({ isMouseOverMenu: true });
  };

  handleMouseLeaveMenu = () => {
    this.setState({ isMouseOverMenu: false });
  };

  render() {
    const { location, categories, history } = this.props;
    const url = location.pathname;

    // 각 헤드 메뉴 url 체크하는 부분 변수화
    const isHomeActive = url === '/';
    const isCategoriesActive = /^\/categories/.test(url) || /^\/@.*\/products\/.*/.test(url);
    const isBrandsActive = /^\/brands/.test(url) || /^\/products\/tags\/.*/.test(url);
    const isEventsActive = /^\/events/.test(url) || /^\/@.*\/events\/.*/.test(url);
    const isFamousActive = /^\/sections\/discount/.test(url);
    const isEstimateActive = /^\/estimate/.test(url) || /^\/@.*\/estimate\/.*/.test(url);
    
    // 블로그 메뉴 활성화 조건: 
    // 1. /posts로 시작하는 URL
    // 2. /@사용자명/posts/ 형식의 URL
    // 3. /@사용자명/blog- 형식의 URL
    // 4. 다른 메뉴가 활성화되지 않았고, /@사용자명/ 형식의 URL인 경우
    const isPostsActive = /^\/posts/.test(url) || 
                         /^\/@.*\/posts\/.*/.test(url) || 
                         /^\/@.*\/blog-.*/.test(url) ||
                         (/^\/@.*\/.+/.test(url) && 
                          !isHomeActive && 
                          !isCategoriesActive && 
                          !isBrandsActive && 
                          !isEventsActive && 
                          !isFamousActive && 
                          !isEstimateActive);

    return (
      <div className="MainMobileHead">
        <ul className="items">
          <MainMobileHeadItem active={isHomeActive} to="/" name="쇼핑홈" />
          <MainMobileHeadItem
            isMouseOver={this.state.isMouseOverMenu}
            handleMouseLeave={this.handleMouseLeaveMenu}
            handleMouseOver={this.handleMouseOverMenu}
            categories={categories}
            history={history}
            active={isCategoriesActive}
            to="/categories"
            name="카테고리"
          />
          <MainMobileHeadItem active={isPostsActive} to="/posts" name="블로그" />
          <MainMobileHeadItem active={isBrandsActive} to="/brands" name="브랜드" />
          <MainMobileHeadItem active={isEventsActive} to="/events" name="이벤트" />
          <MainMobileHeadItem active={isFamousActive} to="/sections/discount" name="특별할인" />
        </ul>
      </div>
    );
  }
}

// export default compose(withRouter)(MainMobileHead);
export default withRouter(MainMobileHead);



// WEBPACK FOOTER //
// ./src/components/main/MainMobileHead/MainMobileHead.js